import { render } from "./PreFormMessage.vue?vue&type=template&id=dc319a38&scoped=true"
import script from "./PreFormMessage.vue?vue&type=script&lang=js"
export * from "./PreFormMessage.vue?vue&type=script&lang=js"

import "./PreFormMessage.vue?vue&type=style&index=0&id=dc319a38&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc319a38"]])

export default __exports__